import React from 'react';
import {t} from '@lingui/core/macro';

import {useServerForm} from 'features/server/model/useServerForm';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import {TagsChipField} from 'entities/monitor';
import {CollapsiblePanel} from 'entities/tariff';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputName from 'shared/ui/Input/InputName';
import IServerOutput from 'features/server/model/Server/IServer';
import {NotifyChannels} from 'entities/notification';

import styles from './ServerForm.module.scss';

interface IServerFormProps {
    item?: IServerOutput,
    // eslint-disable-next-line no-unused-vars
    onCreated: (server: IServerOutput) => void,
    onUpdated: () => void,
    onClose?: () => void,
}

const ServerForm: React.FC<IServerFormProps> = ({item, onCreated, onUpdated, onClose}) => {
    const {form, submit, isNew, isLoading} = useServerForm({item, onCreated, onUpdated});
    const {register, formState, control} = form;
    const {errors, isValid} = formState;

    return (
        <form onSubmit={submit} className={styles.form}>
            <ModalBodyWrapper className={styles.wrapper}>
                <FormGroupWithError error={errors?.name?.message}>
                    <InputName
                        defaultValue={item?.name}
                        name="name"
                        placeholder={t`Название сервера`}
                        register={register}
                        control={control}
                    />
                </FormGroupWithError>
                <span className={styles.hint}>
                    {
                        // eslint-disable-next-line max-len
                        t`Название видно только вам — в карточке сервера и в таблице серверов. Указывать точное системное имя необязательно, подойдёт любое короткое и понятное обозначение.`
                    }
                </span>
                <TagsChipField
                    control={control}
                    label={t`Теги`}
                    error={errors?.tags?.message}
                    className={styles.formGroup}
                />
            </ModalBodyWrapper>
            <ModalBodyWrapper className={styles.wrapper}>
                <CollapsiblePanel
                    title={t`Уведомления`}
                    defaultExpanded
                    className={styles.advancedSettings}
                >
                    <NotifyChannels
                        control={control}
                        register={register}
                        emailFieldName="notify_by_email"
                        additionalEmailsFieldName="additional_emails"
                        telegramFieldName="telegram_chats"
                        maxFieldName="max_chats"
                    />
                </CollapsiblePanel>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={isNew ? t`Продолжить` : t`Сохранить`}
                primaryButtonType="submit"
                primaryButtonLoading={isLoading}
                primaryButtonDisabled={!isValid}
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
};

export default ServerForm;
